import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type {
  UpdateCryptoAddressRequestDto,
  UpdateCryptoAddressResponseDto,
} from '../model';

const updateCryptoAddress = async (
  templateId: string,
  networkName: string,
  args: UpdateCryptoAddressRequestDto,
  options?: RequestHandlerOptions
): Promise<UpdateCryptoAddressResponseDto> => {
  const request = () =>
    apiClient.patch(
      `/operations/crypto/${networkName}/template/${templateId}`,
      args
    );

  const response = await handleRequest<UpdateCryptoAddressResponseDto>(
    request,
    options
  );

  return response.data;
};

const deleteCryptoAddress = async (
  templateId: string,
  networkName: string,
  options?: RequestHandlerOptions
): Promise<void> => {
  const request = () =>
    apiClient.delete(
      `/operations/crypto/${networkName}/template/${templateId}`
    );
  const response = await handleRequest<void>(request, options);
  return response.data;
};

export { updateCryptoAddress, deleteCryptoAddress };
